class IntervalConfig {
    constructor(callback, intervalId, runCallbackOnReset) {
        this.callback = callback;
        this.intervalId = intervalId;
        this.runCallbackOnReset = runCallbackOnReset;
    }
}

function buildPropertyName(intervalName) {
    return `__${intervalName}Interval`;
}

function removeInterval(mapContext, intervalPropertyName) {
    const intervalConfig = mapContext[intervalPropertyName];
    if (!intervalConfig) {
        return null;
    }

    if (intervalConfig.intervalId) {
        clearInterval(intervalConfig.intervalId);
        delete intervalConfig.intervalId;
    }
    return intervalConfig;
}

class PeriodicUpdater {
    remove = (mapContext, intervalName) => {
        const intervalPropertyName = buildPropertyName(intervalName);
        removeInterval(mapContext, intervalPropertyName);
        delete mapContext[intervalPropertyName];
    };

    reset = (mapContext, intervalName, intervalInMillis) => {
        const intervalPropertyName = buildPropertyName(intervalName);
        if (!mapContext[intervalPropertyName]) {
            return;
        }

        const intervalConfig = removeInterval(mapContext, intervalPropertyName);
        intervalConfig.intervalId = setInterval(intervalConfig.callback, intervalInMillis);
        if (intervalConfig.runCallbackOnReset) {
            intervalConfig.callback();
        }
    };

    stop = (mapContext, intervalName) => {
        const intervalPropertyName = buildPropertyName(intervalName);
        if (!mapContext[intervalPropertyName]) {
            return;
        }

        removeInterval(mapContext, intervalPropertyName);
    };

    set = (mapContext, intervalName, intervalInMillis, callback, runCallbackOnReset) => {
        const intervalPropertyName = buildPropertyName(intervalName);

        removeInterval(mapContext, intervalPropertyName);

        const intervalId = setInterval(callback, intervalInMillis);

        mapContext[intervalPropertyName] = new IntervalConfig(callback, intervalId, runCallbackOnReset);
    }
}

export default new PeriodicUpdater();



// WEBPACK FOOTER //
// ./map/periodicUpdater.js